import i18n, { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { commonEn, languageEn } from './english'
import { commonFi, languageFi } from './finnish'
import { commonSv, languageSv } from './swedish'

export const resources = {
  fi: {
    extranet: languageFi,
    common: commonFi,
  },
  sv: {
    extranet: languageSv,
    common: commonSv,
  },
  en: {
    extranet: languageEn,
    common: commonEn,
  },
} as const

const options: Omit<InitOptions, 'resources'> & { resources: typeof resources } = {
  supportedLngs: ['fi', 'en', 'sv'],
  lng: localStorage.getItem('language') || 'fi',
  fallbackLng: 'fi',
  defaultNS: 'extranet',
  ns: ['extranet', 'common'],
  resources,
  interpolation: {
    escapeValue: false, // react already protects against xss
  },
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(options)
